import DOMPurify from 'dompurify';

import { PAGE_BREAK_NODE_NAME } from '../../tiptap/nodes/pageBreak/constants';

/**
 * Every tag a document node serializes to. Without this list DOMPurify unwraps them, and deletes an
 * empty `literature-citation` or `ref` outright - so a missing entry loses content silently.
 *
 * Tags only. A tab and an element row render as a `span` and a `div` carrying a class, so they need
 * no entry.
 */
export const DOCUMENT_HTML_TAGS = Object.freeze([
  'title-node',
  'caption-node',
  'literature-citation',
  'ref',
  PAGE_BREAK_NODE_NAME,
  'reusable-block',
  'inline-block',
  'template-field-block',
  'template-field-inline',
  'template-field-dropdown',
  'selection-node',
  'selection-mark',
]);

/**
 * Attributes the document format uses that DOMPurify does not know, so it would drop them.
 *
 * `target` carries `_blank` on external links. `colwidth` holds a table's column widths, and the
 * renderer rebuilds the `<colgroup>` from it - without it a table lays its columns out differently
 * here than in the editor. Anything named `data-*` is kept already.
 */
export const DOCUMENT_HTML_ATTRS = Object.freeze(['target', 'colwidth']);

const CONFIG = {
  ADD_TAGS: [...DOCUMENT_HTML_TAGS],
  ADD_ATTR: [...DOCUMENT_HTML_ATTRS],
  RETURN_DOM_FRAGMENT: true,
};

/** Only the static half needs this: the editor's schema keeps no attribute it does not declare. */
export const sanitizeElementHtml = (html: string): DocumentFragment =>
  DOMPurify.sanitize(html, CONFIG) as unknown as DocumentFragment;
